/**
 * Fixed LinkedIn targeting options that don't require API search.
 * These options are always available without typing.
 * Uses `id` for retrocompatibility (value is the LinkedIn URN).
 */

import {
  LINKEDIN_STAFF_COUNT_MYSELF_ONLY,
  LINKEDIN_STAFF_COUNT_2_10,
  LINKEDIN_STAFF_COUNT_11_50,
  LINKEDIN_STAFF_COUNT_51_200,
  LINKEDIN_STAFF_COUNT_201_500,
  LINKEDIN_STAFF_COUNT_501_1000,
  LINKEDIN_STAFF_COUNT_1001_5000,
  LINKEDIN_STAFF_COUNT_5001_10000,
  LINKEDIN_STAFF_COUNT_10001_PLUS,
  LINKEDIN_JOB_FUNCTION_ACCOUNTING,
  LINKEDIN_JOB_FUNCTION_ADMINISTRATIVE,
  LINKEDIN_JOB_FUNCTION_ARTS_AND_DESIGN,
  LINKEDIN_JOB_FUNCTION_BUSINESS_DEVELOPMENT,
  LINKEDIN_JOB_FUNCTION_COMMUNITY_AND_SOCIAL_SERVICES,
  LINKEDIN_JOB_FUNCTION_CONSULTING,
  LINKEDIN_JOB_FUNCTION_EDUCATION,
  LINKEDIN_JOB_FUNCTION_ENGINEERING,
  LINKEDIN_JOB_FUNCTION_ENTREPRENEURSHIP,
  LINKEDIN_JOB_FUNCTION_FINANCE,
  LINKEDIN_JOB_FUNCTION_HEALTHCARE_SERVICES,
  LINKEDIN_JOB_FUNCTION_HUMAN_RESOURCES,
  LINKEDIN_JOB_FUNCTION_INFORMATION_TECHNOLOGY,
  LINKEDIN_JOB_FUNCTION_LEGAL,
  LINKEDIN_JOB_FUNCTION_MARKETING,
  LINKEDIN_JOB_FUNCTION_MEDIA_AND_COMMUNICATION,
  LINKEDIN_JOB_FUNCTION_MILITARY_AND_PROTECTIVE_SERVICES,
  LINKEDIN_JOB_FUNCTION_OPERATIONS,
  LINKEDIN_JOB_FUNCTION_PRODUCT_MANAGEMENT,
  LINKEDIN_JOB_FUNCTION_PROGRAM_AND_PROJECT_MANAGEMENT,
  LINKEDIN_JOB_FUNCTION_PURCHASING,
  LINKEDIN_JOB_FUNCTION_QUALITY_ASSURANCE,
  LINKEDIN_JOB_FUNCTION_REAL_ESTATE,
  LINKEDIN_JOB_FUNCTION_RESEARCH,
  LINKEDIN_JOB_FUNCTION_SALES,
  LINKEDIN_JOB_FUNCTION_CUSTOMER_SUCCESS_AND_SUPPORT,
  LINKEDIN_SENIORITY_UNPAID,
  LINKEDIN_SENIORITY_TRAINING,
  LINKEDIN_SENIORITY_ENTRY,
  LINKEDIN_SENIORITY_SENIOR,
  LINKEDIN_SENIORITY_MANAGER,
  LINKEDIN_SENIORITY_DIRECTOR,
  LINKEDIN_SENIORITY_VP,
  LINKEDIN_SENIORITY_CXO,
  LINKEDIN_SENIORITY_PARTNER,
  LINKEDIN_SENIORITY_OWNER,
  LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_JOB_SEEKERS,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_EDUCATION,
  LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_CONTRIBUTORS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_PROMOTED,
  LINKEDIN_MEMBER_BEHAVIOR_CAREER_CHANGERS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_SWITCHED_JOBS,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION,
  LINKEDIN_MEMBER_BEHAVIOR_EXPAT,
  LINKEDIN_MEMBER_BEHAVIOR_MOBILE_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_DESKTOP_LAPTOP_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_DOMESTIC_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_INTERNATIONAL_FREQUENT_TRAVELERS,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_DOMESTIC,
  LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_INTERNATIONAL,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_DOMESTIC,
  LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_INTERNATIONAL,
  LINKEDIN_MEMBER_BEHAVIOR_ANDROID_USERS,
  LINKEDIN_MEMBER_BEHAVIOR_WINDOWS,
  LINKEDIN_MEMBER_BEHAVIOR_MAC,
  LINKEDIN_MEMBER_BEHAVIOR_LINUX,
} from "../i18n/keysTranslations";

export const optionsStaffCountRangesLinkedin = [
  {
    name: "Myself Only",
    id: "urn:li:staffCountRange:(1,1)",
    facetUrn: "urn:li:adTargetingFacet:staffCountRanges",
    labelKey: LINKEDIN_STAFF_COUNT_MYSELF_ONLY,
  },
  {
    name: "2-10 employees",
    id: "urn:li:staffCountRange:(2,10)",
    facetUrn: "urn:li:adTargetingFacet:staffCountRanges",
    labelKey: LINKEDIN_STAFF_COUNT_2_10,
  },
  {
    name: "11-50 employees",
    id: "urn:li:staffCountRange:(11,50)",
    facetUrn: "urn:li:adTargetingFacet:staffCountRanges",
    labelKey: LINKEDIN_STAFF_COUNT_11_50,
  },
  {
    name: "51-200 employees",
    id: "urn:li:staffCountRange:(51,200)",
    facetUrn: "urn:li:adTargetingFacet:staffCountRanges",
    labelKey: LINKEDIN_STAFF_COUNT_51_200,
  },
  {
    name: "201-500 employees",
    id: "urn:li:staffCountRange:(201,500)",
    facetUrn: "urn:li:adTargetingFacet:staffCountRanges",
    labelKey: LINKEDIN_STAFF_COUNT_201_500,
  },
  {
    name: "501-1000 employees",
    id: "urn:li:staffCountRange:(501,1000)",
    facetUrn: "urn:li:adTargetingFacet:staffCountRanges",
    labelKey: LINKEDIN_STAFF_COUNT_501_1000,
  },
  {
    name: "1001-5000 employees",
    id: "urn:li:staffCountRange:(1001,5000)",
    facetUrn: "urn:li:adTargetingFacet:staffCountRanges",
    labelKey: LINKEDIN_STAFF_COUNT_1001_5000,
  },
  {
    name: "5001-10,000 employees",
    id: "urn:li:staffCountRange:(5001,10000)",
    facetUrn: "urn:li:adTargetingFacet:staffCountRanges",
    labelKey: LINKEDIN_STAFF_COUNT_5001_10000,
  },
  {
    name: "10,001+ employees",
    id: "urn:li:staffCountRange:(10001,2147483647)",
    facetUrn: "urn:li:adTargetingFacet:staffCountRanges",
    labelKey: LINKEDIN_STAFF_COUNT_10001_PLUS,
  },
];

export const optionsJobFunctionsLinkedin = [
  {
    name: "Accounting",
    id: "urn:li:function:1",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_ACCOUNTING,
  },
  {
    name: "Administrative",
    id: "urn:li:function:2",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_ADMINISTRATIVE,
  },
  {
    name: "Arts and Design",
    id: "urn:li:function:3",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_ARTS_AND_DESIGN,
  },
  {
    name: "Business Development",
    id: "urn:li:function:4",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_BUSINESS_DEVELOPMENT,
  },
  {
    name: "Community and Social Services",
    id: "urn:li:function:5",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_COMMUNITY_AND_SOCIAL_SERVICES,
  },
  {
    name: "Consulting",
    id: "urn:li:function:6",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_CONSULTING,
  },
  {
    name: "Education",
    id: "urn:li:function:7",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_EDUCATION,
  },
  {
    name: "Engineering",
    id: "urn:li:function:8",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_ENGINEERING,
  },
  {
    name: "Entrepreneurship",
    id: "urn:li:function:9",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_ENTREPRENEURSHIP,
  },
  {
    name: "Finance",
    id: "urn:li:function:10",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_FINANCE,
  },
  {
    name: "Healthcare Services",
    id: "urn:li:function:11",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_HEALTHCARE_SERVICES,
  },
  {
    name: "Human Resources",
    id: "urn:li:function:12",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_HUMAN_RESOURCES,
  },
  {
    name: "Information Technology",
    id: "urn:li:function:13",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_INFORMATION_TECHNOLOGY,
  },
  {
    name: "Legal",
    id: "urn:li:function:14",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_LEGAL,
  },
  {
    name: "Marketing",
    id: "urn:li:function:15",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_MARKETING,
  },
  {
    name: "Media and Communication",
    id: "urn:li:function:16",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_MEDIA_AND_COMMUNICATION,
  },
  {
    name: "Military and Protective Services",
    id: "urn:li:function:17",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_MILITARY_AND_PROTECTIVE_SERVICES,
  },
  {
    name: "Operations",
    id: "urn:li:function:18",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_OPERATIONS,
  },
  {
    name: "Product Management",
    id: "urn:li:function:19",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_PRODUCT_MANAGEMENT,
  },
  {
    name: "Program and Project Management",
    id: "urn:li:function:20",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_PROGRAM_AND_PROJECT_MANAGEMENT,
  },
  {
    name: "Purchasing",
    id: "urn:li:function:21",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_PURCHASING,
  },
  {
    name: "Quality Assurance",
    id: "urn:li:function:22",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_QUALITY_ASSURANCE,
  },
  {
    name: "Real Estate",
    id: "urn:li:function:23",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_REAL_ESTATE,
  },
  {
    name: "Research",
    id: "urn:li:function:24",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_RESEARCH,
  },
  {
    name: "Sales",
    id: "urn:li:function:25",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_SALES,
  },
  {
    name: "Customer Success and Support",
    id: "urn:li:function:26",
    facetUrn: "urn:li:adTargetingFacet:jobFunctions",
    labelKey: LINKEDIN_JOB_FUNCTION_CUSTOMER_SUCCESS_AND_SUPPORT,
  },
];

export const optionsSenioritiesLinkedin = [
  {
    name: "Unpaid",
    id: "urn:li:seniority:1",
    facetUrn: "urn:li:adTargetingFacet:seniorities",
    labelKey: LINKEDIN_SENIORITY_UNPAID,
  },
  {
    name: "Training",
    id: "urn:li:seniority:2",
    facetUrn: "urn:li:adTargetingFacet:seniorities",
    labelKey: LINKEDIN_SENIORITY_TRAINING,
  },
  {
    name: "Entry",
    id: "urn:li:seniority:3",
    facetUrn: "urn:li:adTargetingFacet:seniorities",
    labelKey: LINKEDIN_SENIORITY_ENTRY,
  },
  {
    name: "Senior",
    id: "urn:li:seniority:4",
    facetUrn: "urn:li:adTargetingFacet:seniorities",
    labelKey: LINKEDIN_SENIORITY_SENIOR,
  },
  {
    name: "Manager",
    id: "urn:li:seniority:5",
    facetUrn: "urn:li:adTargetingFacet:seniorities",
    labelKey: LINKEDIN_SENIORITY_MANAGER,
  },
  {
    name: "Director",
    id: "urn:li:seniority:6",
    facetUrn: "urn:li:adTargetingFacet:seniorities",
    labelKey: LINKEDIN_SENIORITY_DIRECTOR,
  },
  {
    name: "VP",
    id: "urn:li:seniority:7",
    facetUrn: "urn:li:adTargetingFacet:seniorities",
    labelKey: LINKEDIN_SENIORITY_VP,
  },
  {
    name: "CXO",
    id: "urn:li:seniority:8",
    facetUrn: "urn:li:adTargetingFacet:seniorities",
    labelKey: LINKEDIN_SENIORITY_CXO,
  },
  {
    name: "Partner",
    id: "urn:li:seniority:9",
    facetUrn: "urn:li:adTargetingFacet:seniorities",
    labelKey: LINKEDIN_SENIORITY_PARTNER,
  },
  {
    name: "Owner",
    id: "urn:li:seniority:10",
    facetUrn: "urn:li:adTargetingFacet:seniorities",
    labelKey: LINKEDIN_SENIORITY_OWNER,
  },
];

export const optionsMemberBehaviorsLinkedin = [
  {
    name: "Frequent Travelers",
    id: "urn:li:memberBehavior:9",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_TRAVELERS,
  },
  {
    name: "Job Seekers",
    id: "urn:li:memberBehavior:12",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_JOB_SEEKERS,
  },
  {
    name: "Open to Education",
    id: "urn:li:memberBehavior:13",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_EDUCATION,
  },
  {
    name: "Frequent Contributors",
    id: "urn:li:memberBehavior:14",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_FREQUENT_CONTRIBUTORS,
  },
  {
    name: "Recently Relocated",
    id: "urn:li:memberBehavior:15",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED,
  },
  {
    name: "Recently Promoted",
    id: "urn:li:memberBehavior:18",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_PROMOTED,
  },
  {
    name: "Career Changers",
    id: "urn:li:memberBehavior:19",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_CAREER_CHANGERS,
  },
  {
    name: "Recently Switched Jobs",
    id: "urn:li:memberBehavior:20",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_SWITCHED_JOBS,
  },
  {
    name: "Open to Relocation",
    id: "urn:li:memberBehavior:21",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION,
  },
  {
    name: "Ex-pat",
    id: "urn:li:memberBehavior:24",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_EXPAT,
  },
  {
    name: "Mobile Users",
    id: "urn:li:memberBehavior:2",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_MOBILE_USERS,
  },
  {
    name: "Desktop/Laptop Users",
    id: "urn:li:memberBehavior:5",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_DESKTOP_LAPTOP_USERS,
  },
  {
    name: "Domestic Frequent Travelers",
    id: "urn:li:memberBehavior:10",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_DOMESTIC_FREQUENT_TRAVELERS,
  },
  {
    name: "International Frequent Travelers",
    id: "urn:li:memberBehavior:11",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_INTERNATIONAL_FREQUENT_TRAVELERS,
  },
  {
    name: "Recently Relocated (Domestic)",
    id: "urn:li:memberBehavior:16",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_DOMESTIC,
  },
  {
    name: "Recently Relocated (International)",
    id: "urn:li:memberBehavior:17",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_RECENTLY_RELOCATED_INTERNATIONAL,
  },
  {
    name: "Open to Relocation (Domestic)",
    id: "urn:li:memberBehavior:22",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_DOMESTIC,
  },
  {
    name: "Open to Relocation (International)",
    id: "urn:li:memberBehavior:23",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_OPEN_TO_RELOCATION_INTERNATIONAL,
  },
  {
    name: "Android Users",
    id: "urn:li:memberBehavior:4",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_ANDROID_USERS,
  },
  {
    name: "Windows",
    id: "urn:li:memberBehavior:6",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_WINDOWS,
  },
  {
    name: "Mac",
    id: "urn:li:memberBehavior:7",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_MAC,
  },
  {
    name: "Linux",
    id: "urn:li:memberBehavior:8",
    facetUrn: "urn:li:adTargetingFacet:memberBehaviors",
    labelKey: LINKEDIN_MEMBER_BEHAVIOR_LINUX,
  },
];
